import { render, staticRenderFns } from "./club-pricing.vue?vue&type=template&id=f4a98b18&"
import script from "./club-pricing.vue?vue&type=script&lang=js&"
export * from "./club-pricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports